const generateNumbersRange = (min: number, max: number): number[] => {
  if (min > max) {
    return [];
  }

  return Array.from({ length: max - min + 1 }, (_, i) => min + i);
};

export default generateNumbersRange;
